// extracted by mini-css-extract-plugin
export default {"root":"style_root__XsvFg","trigger":"style_trigger__hTeyX","container":"style_container__-Lj9R","arrow":"style_arrow__k1pko","image":"style_image__hRukG","text":"style_text__kM6JD"};